import React, { Component } from 'react';
import { Card, CardBody, CardLink, Button, Modal, ModalHeader, ModalBody, Col, Row } from 'reactstrap'
import Fetch from '../../Auxiliares/fetch'
import ModUsuario from '../../Paginas/Admin/modUsuario'
import modificarImg from '../../Img/modificar.png'
import eliminarImg from '../../Img/eliminar.png'

export default class usuariosCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDelModalOpen: null,
            isModModalOpen: null
        }

        this.toggleDel = this.toggleDel.bind(this)
        this.toggleMod = this.toggleMod.bind(this)
    }

    toggleDel(obj) {
        this.setState({
            isDelModalOpen: obj ? obj : null
        })
    }

    toggleMod(obj) {
        this.setState({
            isModModalOpen: obj ? obj : null
        })
    }

    eliminar = (id) => {
        Fetch('/api/deleteUsuario', {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id })
        })
            .then(response => {
                this.props.actualizar();
                this.toggleDel();
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 602:
                        console.log('Este usuario no existe')
                        break;

                    default:
                        break;
                }
            })
    }


    render() {
        return (
            <div className="col-12">
                <Card className={this.props.encabezado ? "mb-1 col-12 py-2 bg-secondary text-white" : "mb-1 col-12 py-2"}>
                    <Row className="p-1 col-12 mx-1">
                        <Col sm="2"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Usuario" : this.props.usuario}</Col>
                        <Col sm="3"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Nombre" : this.props.nombre+' '+this.props.ap_paterno+' '+this.props.ap_materno}</Col>
                        <Col sm="4"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Rol" : this.props.rol}</Col>
                        <Col sm="2"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Estado" : this.props.habilitarUso ? <div className="text-success d-inline">Activada</div> : <div className="text-danger d-inline">Desactivada</div>}</Col>
                        <Col >{this.props.encabezado ? <div/> : <img className="img-responsive clicable" alt="modificar imagen" src={modificarImg} onClick={() => { this.toggleMod(this.props) }} />}</Col>
                        <Col >{this.props.encabezado ? <div/> : <img className="img-responsive clicable" alt="eliminar imagen" src={eliminarImg} onClick={() => { this.toggleDel(this.props) }} />}</Col>
                    </Row>
                </Card>

                <Modal isOpen={this.state.isDelModalOpen !== null} toggle={() => this.toggleDel()}
                    className="modal-md">
                    <ModalHeader toggle={() => this.toggleDel()}>Eliminar</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="p-3 text-center">
                                    ¿Esta seguro de que desea eliminar este estudiante?
                                    <div className="font-weight-bold">
                                        {this.props.nombre+' '+this.props.ap_paterno+' '+this.props.ap_materno}
                                    </div>
                                    <CardBody>
                                        <CardLink><Button className="btn-danger" onClick={() => this.eliminar(this.state.isDelModalOpen.id)}>Aceptar</Button></CardLink>
                                        <CardLink><Button className="btn-light" onClick={() => this.toggleDel()}>Cancelar</Button></CardLink>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isModModalOpen !== null} toggle={() => this.toggleMod()}
                    className="modal-md">
                    <ModalHeader toggle={() => this.toggleMod()}>Modificar</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="p-3 border-0">
                                    <div>
                                        <ModUsuario id={this.props.id} usuario={this.props.usuario} nombre={this.props.nombre} ap_paterno={this.props.ap_paterno} ap_materno={this.props.ap_materno} rfc={this.props.rfc} rol={this.props.rol} correo={this.props.correo} habilitarUso={this.props.habilitarUso} cerrar={this.toggleMod} actualizar={this.props.actualizar}/>
                                    </div>
                                </Card>
                            </Col>

                        </Row>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}